import card27 from './27.jpg';
import card28 from './28.jpg';
import card29 from './29.jpg';
import card30 from './30.jpg';
import card31 from './31.jpg';
import card32 from './32.jpg';
import card33 from './33.jpg';
import card34 from './34.jpg';
import card35 from './35.jpg';
import card36 from './36.jpg';
import card37 from './37.jpg';
import card38 from './38.jpg';
import card39 from './39.jpg';

const cards_data2 = [
    {
        image:card27,
        
    },
    {
        image:card28,
        
    },
    {
        image:card29,
        
    },
    {
        image:card30,
        
    },
    {
        image:card31,
        
    },
    {
        image:card32,
        
    },
    {
        image:card33,
        
    },
    {
        image:card34,
        
    },
    {
        image:card35,
        
    },
    {
        image:card36,
        
    },
    {
        image:card37,
        
    },
    {
        image:card38,
        
    },
    {
        image:card39,
        
    }
]
export default cards_data2;